import React from "react"

export default ({ text }) => <div className="tag">{text}</div>
